




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import DossierApi from '@/store/api/DossierApi';
import Snackbar from '@/components/shared/Snackbar.vue';

@Component({ components: { Snackbar } })
export default class DossierInboundsNoticeOfLoss extends Vue {
  @Prop({ type: String, required: true }) inboundCode!: string;
  @Prop({ type: String, required: true }) idCompany!: string;

  dossierApi = new DossierApi();
  groupedNotices: any[] = [];
  expanded: any[] = [];
  loadingNoticeOfLoss = false;

  async mounted() {
      await this.loadInboundsNoticeOfLoss();
  }

  async loadInboundsNoticeOfLoss() {
      if (!this.inboundCode) return;
      this.loadingNoticeOfLoss = true;

      try {
          const data = await this.dossierApi.DossierReadInboundNoticeOfLoss(this.inboundCode);

          this.groupedNotices = Object.values(
              data.reduce((acc: any, curr: any) => {
                  const groupKey = curr.idNoticeOfLoss || curr.id; // 🔹 agrupamos por NoticeOfLoss
                  if (!acc[groupKey]) {
                      acc[groupKey] = {
                          id: groupKey,
                          date: curr.date,
                          warehouseName: curr.warehouseName || curr.warehouse,
                          description: curr.description || "",
                          totalLost: 0,
                          details: []
                      };
                  }

                  // Agregamos el detalle
                  acc[groupKey].details.push({
                      idNoticeOfLoss: groupKey,
                      idPallet: curr.idPallet,
                      palletType: curr.listPalletName || curr.palletType,
                      casesPerPallet: curr.casesPerPallet,
                      goodsPerCase: curr.goodsPerCase,
                      totalGoods: curr.totalGoods
                  });

                  // Sumamos totales
                  acc[groupKey].totalLost += curr.totalGoods || 0;

                  return acc;
              }, {})
          );
      } catch (err) {
          console.error(err);
      } finally {
          this.loadingNoticeOfLoss = false;
      }
  }
  formatDate(dateStr: string) {
      if (!dateStr) return '';
      return new Date(dateStr).toLocaleDateString();
  }

  noticeOfLossHeaders = [
      { text: 'Date', value: 'date' },
      { text: 'Warehouse', value: 'warehouseName' },
      { text: 'Total Lost Goods', value: 'totalLost' }
  ];

  noticeOfLossDetailHeaders = [
      { text: 'Pallet Type', value: 'palletType' },
      { text: 'Pallet ID', value: 'idPallet' },
      { text: 'Cases/Pallet', value: 'casesPerPallet' },
      { text: 'Goods/Case', value: 'goodsPerCase' },
      { text: 'Total Goods', value: 'totalGoods' }
  ];
}
